import { BALANCE_LIMIT_ACTION_TYPE } from "./balance-limit.action";

export const BALANCE_LIMIT_MESSAGE_CONTEXT = {
	get: BALANCE_LIMIT_ACTION_TYPE.get,
	update: BALANCE_LIMIT_ACTION_TYPE.update,
};

export const BALANCE_LIMIT_MESSAGE_CODE = {
	getError: "M_BALANCE_LIMIT_GET_ERROR",
	updateSuccess: "M_BALANCE_LIMIT_UPDATE_SUCCESS",
	updateError: "M_BALANCE_LIMIT_UPDATE_ERROR",
};
